/**
 * @file 测评模板相关 API 定义
 * @author linchunqing
 */

import { API_TYPE } from '@umu/umu-fetch';

const BASE_URI = '/uapi/v1/template/assessment';

/**
 * 获取测评模板列表
 */
export const GET_ASSESSMENT_TEMPLATE_LIST = {
    url: `${BASE_URI}/list`,
    type: API_TYPE.GET,
};

/**
 * 获取测评模板详情
 */
export const GET_ASSESSMENT_TEMPLATE_DETAIL = {
    url: `${BASE_URI}/detail`,
    type: API_TYPE.GET,
};

/**
 * 使用模板创建测评
 */
export const USE_ASSESSMENT_TEMPLATE = {
    url: `${BASE_URI}/use`,
    type: API_TYPE.POST,
};

/**
 * 创建模板
 */
export const CREATE_ASSESSMENT_TEMPLATE = {
    url: `${BASE_URI}/create`,
    type: API_TYPE.POST,
};

/**
 * 删除模板
 */
export const DELETE_ASSESSMENT_TEMPLATE = {
    url: `${BASE_URI}/delete`,
    type: API_TYPE.POST,
};

/**
 * 获取当前权限设置
 */
export const GET_ACCESS_PERMISSION = {
    url: `${BASE_URI}/get-access-permission`,
    type: API_TYPE.GET,
};
/**
 * 设置权限类型
 */
export const SET_ACCESS_PERMISSION = {
    url: `${BASE_URI}/set-access-permission`,
    type: API_TYPE.POST,
};
/**
 * 添加指定账户
 */
export const SET_USER_ACCESS_PERMISSION = {
    url: `${BASE_URI}/set-user-access-permission`,
    type: API_TYPE.POST,
};
/**
 *  移除指定账户
 */
export const REMOVE_USER_ACCESS_PERMISSION = {
    url: `${BASE_URI}/remove-user-access-permission`,
    type: API_TYPE.POST,
};
/**
 *  已授权账户列表
 */
export const ACCESS_USER_LIST = {
    url: `${BASE_URI}/access-user-list`,
    type: API_TYPE.GET,
};
/**
 *  已授权账户列表
 */
export const PERMISSION_OVERVIEW = {
    url: `${BASE_URI}/permission-overview`,
    type: API_TYPE.GET,
};